import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import PrintLink from './PrintLink/PrintLink';
import './ConfirmationPageDisclaimer.css';
import { useWidthContext } from '../../providers/Width';
import { Image } from '../../importCL';

interface IConfirmationpageDisclaimerProps extends MappedComponentProperties {
    desktopPrint?: string;
    mobilePrint?: string;
    icon?: string;
    altText?: string;
}

export const ConfirmationPageDisclaimerEditConfig = {
    emptyLabel: 'Confirmation Page Disclaimer',
    isEmpty: (props: PropsWithChildren<IConfirmationpageDisclaimerProps>) => {
        return !props || !props.desktopPrint || !props.mobilePrint;
    },
};

const ConfirmationPageDisclaimer = (
    props: PropsWithChildren<IConfirmationpageDisclaimerProps>,
): JSX.Element => {
    const { width } = useWidthContext();


    return (
        <div id='confirmation-page-disclaimer' className='ConfirmationPageDisclaimer'>
            <div className='ConfirmationPageDisclaimer__container'>

                <Image className='ConfirmationPageDisclaimer__icon' loading='lazy' src={props.icon} alt={props.altText} />
                <div className='ConfirmationPageDisclaimer__text ConfirmationPageDisclaimer__hidden-mobile'>
                    <p> <span>For your security, please close your browser after you </span>
                        <PrintLink>{width > 767 ? props.desktopPrint : props.mobilePrint}</PrintLink>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationPageDisclaimer;


